import moment from 'moment-timezone'
const util = {}
util.timeRangeHandle = (timeRange, format) => {
  if (!timeRange) return [undefined, undefined]
  let [startTime, endTime] = timeRange;
  if (typeof (startTime) === 'number' && typeof (endTime) === 'number') {
    return [startTime, endTime]
  }
  if (!!startTime && !!endTime) {
    // 把时间范围处理成0:00~23:59
    startTime = moment(startTime, format).add(12, 'h')
      .clone()
      .startOf("day")
      .valueOf();
    endTime = moment(endTime, format).add(12, 'h')
      .clone()
      .endOf("day")
      .valueOf();
  }
  // 格式化
  if (startTime) startTime = moment(startTime).valueOf();
  if (endTime) endTime = moment(endTime).valueOf();
  return [startTime, endTime];
};

util.lang = (params) => {
  if (!params) return
  return $vm.$i18n.locale == 'km' ? params?.nameKh ?? params.nameKm : $vm.$i18n.locale == 'zh' ? params.nameZh : params?.name ?? params.nameEn
}
util.AmtThousandsFmt = (data) => {
  if (!data) {
    return '0.00';
  }
  const ret = ((parseFloat(((data - 0) || 0), 10) - 0).toFixed(2)).toLocaleString() || data.toString();
  return ret === '0' && '0.00' || (ret.indexOf('.') === -1 && `${ret}.00` || ret);
}
/**
  * @description 数字对象处理
  * @param {Object} moneyObj 待处理数字
  */
const moneyFlagMap = {
  USD: "$"
};
util.money = (moneyObj = {}) => {
  if (moneyObj === null) {
    return `${moneyFlagMap[currency]}${util.AmtThousandsFmt(0)}`;
  }
  if (typeof moneyObj !== 'object') {
    moneyObj = {
      amount: ['string', 'number'].indexOf(typeof moneyObj) !== -1 && moneyObj || 0,
      currency: 'USD'
    };
  }
  const { amount, currency = 'USD' } = moneyObj;
  return `${moneyFlagMap[currency]}${util.AmtThousandsFmt(amount)}`;
}

util.isType = type => val => {
  return (
    Object.prototype.toString.call(val).toLowerCase() ===
     `[object ${type}]`.toLowerCase()
  )
}
//  是否是数字
util.isNumber = data => /^-?[0-9]+\.?[0-9]{0,}$/.test(String(data))
//  转换数字
util.toNumber = num => num - 0 || 0
//  四舍五入
util.toFixed = num => util.toNumber(util.toNumber(num).toFixed(2))

util.toPercent = (rate) => {
  const afterPercent = rate + '%'
  return afterPercent
}
util.timeout = (callback, timestamp) => {
  const __timeout = setTimeout(() => {
    clearTimeout(__timeout);
    typeof callback === 'function' && callback();
  }, timestamp);
}
util.getLabel = (val) => `${val}${$vm.$i18n.t(common.semicolon)}`

/**
 * 对象深拷贝
 */
util.deepClone = data => {
  var type = getObjType(data);
  var obj;
  if (type === 'array') obj = [];
  else if (type === 'object') obj = {};
  else return data;
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      data[i] = (() => {
        if (data[i] === 0) {
          return data[i];
        }
        return data[i];
      })();
      if (data[i]) {
        delete data[i].$parent;
      }
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      if (data) {
        delete data.$parent;
      }
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};
// 下载一个链接
util.download = (link, name) => {
  if (!name) name = link.slice(link.lastIndexOf('/') + 1)
  const eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.style.display = 'none'
  eleLink.href = link
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}

// 自定义一些下载内容
util.downLoadFile = (name, count) => {
  if (typeof name === 'undefined') {
    throw new Error('The first parameter name is a must')
  }
  if (typeof content === 'undefined') {
    throw new Error('The second parameter content is a must')
  }
  if (!(content instanceof Blob)) {
    content = new Blob([content])
  }
  const link = URL.createObjectURL(content)
  util.download(link, name)
}
// 清除对象中为null,'',undefined的属性
util.clearObject = object => {
  if (!object) return {}
  const result = { ...object }
  Object.keys(result).forEach(key => {
    const value = result[key]
    if (value === undefined || value === null || value === "") delete result[key]
  })
  return result
}
export default util
